import { DIFFICULTY_LEVELS, QUESTION_TYPES } from '../questionTypes';

// 30 Preguntas del Músculo Esternocleidomastoideo
// 10 Básicas + 10 Generales + 10 Complejas

export const esternocleidomastoideoQuestions = [
  
  // ========== NIVEL BÁSICO (10) ==========
  
  {
    id: 10211,
    muscle: 'esternocleidomastoideo',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.CONCEPTO,
    question: "¿Qué significa el nombre 'esternocleidomastoideo'?",
    options: [
      "Del esternón al mastoides pasando por la clavícula",
      "Músculo del cuello anterior",
      "Elevador de la cabeza",
      "Rotador cervical"
    ],
    correctAnswer: 0,
    explanation: "El nombre 'esternocleidomastoideo' indica los puntos de origen e inserción: esternón (esternón), clavícula (cleido) y apófisis mastoides (mastoideo). Es el músculo más superficial del cuello y forma el límite lateral del triángulo anterior del cuello."
  },
  
  {
    id: 10212,
    muscle: 'esternocleidomastoideo',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.IDENTIFICACION,
    question: "¿Dónde se origina la cabeza esternal del esternocleidomastoideo?",
    options: [
      "Apófisis mastoides",
      "Borde anterior del manubrio esternal",
      "Tercio medial de la clavícula",
      "Apófisis transversa de C1"
    ],
    correctAnswer: 1,
    explanation: "La cabeza esternal del esternocleidomastoideo se origina en el borde anterior del manubrio esternal. Ambas cabezas (esternal y clavicular) se unen para formar el vientre muscular que se inserta en la apófisis mastoides del temporal."
  },
  
  {
    id: 10213,
    muscle: 'esternocleidomastoideo',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.FUNCION,
    question: "¿Cuál es la acción principal del esternocleidomastoideo en contracción unilateral?",
    options: [
      "Flexión del cuello",
      "Rotación de la cabeza al lado opuesto",
      "Elevación de la cabeza",
      "Extensión del cuello"
    ],
    correctAnswer: 1,
    explanation: "La contracción unilateral del esternocleidomastoideo rota la cabeza hacia el lado opuesto y la inclina lateralmente hacia el mismo lado. Es el principal rotador cervical y su acción es esencial para movimientos finos de la cabeza."
  },
  
  {
    id: 10214,
    muscle: 'esternocleidomastoideo',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.INERVACION,
    question: "¿Qué nervio inerva al esternocleidomastoideo?",
    options: [
      "Nervio accesorio (XI par)",
      "Nervio hipogloso (XII par)",
      "Plexo cervical (C2-C3)",
      "Nervio vago (X par)"
    ],
    correctAnswer: 0,
    explanation: "El nervio accesorio (XI par craneal) inerva al esternocleidomastoideo. Este nervio emerge del foramen yugular y desciende posterior al esternocleidomastoideo para inervarlo. La lesión del nervio accesorio causa debilidad del músculo."
  },
  
  {
    id: 10215,
    muscle: 'esternocleidomastoideo',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.VASCULARIZACION,
    question: "¿Qué arteria irriga principalmente al esternocleidomastoideo?",
    options: [
      "Arteria carótida externa",
      "Arteria carótida interna",
      "Arteria occipital",
      "Arteria tiroidea superior"
    ],
    correctAnswer: 0,
    explanation: "La arteria carótida externa irriga al esternocleidomastoideo a través de ramas musculares directas. Esta arteria superficial discurre medial al músculo y proporciona irrigación colateral importante en caso de oclusión carotídea."
  },
  
  {
    id: 10216,
    muscle: 'esternocleidomastoideo',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.RELACION,
    question: "¿Qué estructura se encuentra profunda al esternocleidomastoideo?",
    options: [
      "Piel únicamente",
      "Músculos escalenos",
      "Vena yugular interna",
      "Todas las anteriores"
    ],
    correctAnswer: 3,
    explanation: "Profundo al esternocleidomastoideo se encuentran la vena yugular interna, arteria carótida común, nervios vagos y glosofaríngeos, y los músculos escalenos. Esta disposición explica por qué el músculo es una importante referencia anatómica en cirugía cervical."
  },
  
  {
    id: 10217,
    muscle: 'esternocleidomastoideo',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.CONCEPTO,
    question: "¿Cuántas cabezas tiene el esternocleidomastoideo?",
    options: ["Una", "Dos", "Tres", "Cuatro"],
    correctAnswer: 1,
    explanation: "El esternocleidomastoideo tiene dos cabezas de origen: esternal (del manubrio) y clavicular (del tercio medial de la clavícula). Ambas convergen en un vientre muscular único que se inserta en la apófisis mastoides. Esta disposición permite sus múltiples acciones."
  },
  
  {
    id: 10218,
    muscle: 'esternocleidomastoideo',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.IDENTIFICACION,
    question: "¿Dónde se inserta el tendón del esternocleidomastoideo?",
    options: [
      "Apófisis estiloides del temporal",
      "Apófisis mastoides del temporal",
      "Cóndilo occipital",
      "Apófisis transversa de atlas"
    ],
    correctAnswer: 1,
    explanation: "El esternocleidomastoideo se inserta en la apófisis mastoides del hueso temporal, específicamente en su cara lateral. Esta inserción craneal permite al músculo actuar como potente flexor lateral y rotador de la cabeza."
  },
  
  {
    id: 10219,
    muscle: 'esternocleidomastoideo',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.FUNCION,
    question: "¿Qué acción realiza el esternocleidomastoideo en contracción bilateral?",
    options: [
      "Rotación de la cabeza",
      "Inclinación lateral de la cabeza",
      "Flexión del cuello hacia adelante",
      "Extensión del cuello"
    ],
    correctAnswer: 2,
    explanation: "La contracción bilateral del esternocleidomastoideo produce flexión del cuello hacia adelante. Es uno de los principales flexores cervicales junto con los músculos largos del cuello. Esta acción es importante para movimientos de flexión de la cabeza."
  },
  
  {
    id: 10220,
    muscle: 'esternocleidomastoideo',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.CONCEPTO,
    question: "¿Por qué el esternocleidomastoideo es importante en la respiración?",
    options: [
      "Es un músculo respiratorio accesorio",
      "Ayuda en la inspiración forzada",
      "Fija las costillas durante la respiración",
      "Todas las anteriores"
    ],
    correctAnswer: 1,
    explanation: "El esternocleidomastoideo actúa como músculo respiratorio accesorio durante la inspiración forzada, especialmente cuando hay obstrucción de vías aéreas superiores. Eleva el esternón y clavícula, aumentando el volumen torácico. Es importante en casos de dificultad respiratoria."
  },
  
  // ========== NIVEL GENERAL (10) ==========
  
  {
    id: 10221,
    muscle: 'esternocleidomastoideo',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.FUNCION,
    question: "¿Cómo contribuye el esternocleidomastoideo a la estabilidad cervical?",
    options: [
      "Como flexor principal",
      "Como estabilizador lateral",
      "Como extensor cervical",
      "No contribuye a la estabilidad"
    ],
    correctAnswer: 1,
    explanation: "El esternocleidomastoideo actúa como estabilizador lateral de la columna cervical durante movimientos de la cabeza. Su contracción tónica ayuda a mantener la alineación cervical y previene movimientos laterales excesivos. Es importante en el control postural."
  },
  
  {
    id: 10222,
    muscle: 'esternocleidomastoideo',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.RELACION,
    question: "¿Qué músculos actúan como antagonistas del esternocleidomastoideo en la rotación?",
    options: [
      "Trapecio contralateral",
      "Elevador de la escápula",
      "Romboides",
      "Todos los anteriores"
    ],
    correctAnswer: 0,
    explanation: "El trapecio contralateral actúa como antagonista principal del esternocleidomastoideo en la rotación cervical. Mientras el esternocleidomastoideo rota la cabeza hacia un lado, el trapecio contralateral la rota hacia el lado opuesto. Esta acción coordinada permite movimientos finos de la cabeza."
  },
  
  {
    id: 10223,
    muscle: 'esternocleidomastoideo',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.VASCULARIZACION,
    question: "¿Qué rama específica de la arteria carótida externa irriga al esternocleidomastoideo?",
    options: [
      "Arteria tiroidea superior",
      "Arteria lingual",
      "Arteria facial",
      "Arteria faríngea ascendente"
    ],
    correctAnswer: 0,
    explanation: "La arteria tiroidea superior, primera rama de la carótida externa, irriga la porción inferior del esternocleidomastoideo. Las ramas musculares directas de la carótida externa proporcionan irrigación adicional a la porción superior del músculo."
  },
  
  {
    id: 10224,
    muscle: 'esternocleidomastoideo',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.INERVACION,
    question: "¿Cómo se distribuye la inervación del nervio accesorio en el esternocleidomastoideo?",
    options: [
      "Inerva todo el músculo uniformemente",
      "Inerva principalmente la cabeza esternal",
      "Inerva ambas cabezas de manera similar",
      "Inerva solo la cabeza clavicular"
    ],
    correctAnswer: 2,
    explanation: "El nervio accesorio inerva ambas cabezas del esternocleidomastoideo de manera uniforme. Las ramas nerviosas penetran el músculo en su tercio medio, proporcionando inervación motora a todas las fibras musculares. Esta distribución asegura contracción coordinada."
  },
  
  {
    id: 10225,
    muscle: 'esternocleidomastoideo',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.VARIANTE,
    question: "¿Cuál es la variante anatómica más común del esternocleidomastoideo?",
    options: [
      "Ausencia congénita",
      "Cabeza accesoria",
      "Inserción doble en el temporal",
      "Fusión con trapecio"
    ],
    correctAnswer: 1,
    explanation: "La presencia de una cabeza accesoria (generalmente originándose del esternón o fascia cervical) es la variante más común del esternocleidomastoideo, ocurriendo en 5-10% de la población. Puede causar confusión durante disecciones quirúrgicas."
  },
  
  {
    id: 10226,
    muscle: 'esternocleidomastoideo',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.CORRELACION_CLINICA,
    question: "¿Qué test clínico evalúa la integridad del nervio accesorio?",
    options: [
      "Test de rotación cervical",
      "Test de encogimiento de hombros",
      "Test de flexión cervical",
      "Test de inclinación lateral"
    ],
    correctAnswer: 1,
    explanation: "El test de encogimiento de hombros evalúa la integridad del nervio accesorio al observar la capacidad del paciente para elevar los hombros contra resistencia. La debilidad indica lesión del nervio accesorio, que inerva tanto al trapecio como al esternocleidomastoideo."
  },
  
  {
    id: 10227,
    muscle: 'esternocleidomastoideo',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.EMBRIOLOGIA,
    question: "¿De qué arco faríngeo se desarrolla el esternocleidomastoideo?",
    options: [
      "Primer arco faríngeo",
      "Segundo arco faríngeo",
      "Tercer arco faríngeo",
      "Mesénquima occipital"
    ],
    correctAnswer: 1,
    explanation: "El esternocleidomastoideo se desarrolla del mesénquima del segundo arco faríngeo, al igual que el músculo trapecio. Esta origen común explica por qué ambos músculos están inervados por el nervio accesorio y comparten algunas características embriológicas."
  },
  
  {
    id: 10228,
    muscle: 'esternocleidomastoideo',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.HISTOLOGIA,
    question: "¿Qué proporción aproximada de fibras musculares tiene el esternocleidomastoideo?",
    options: [
      "90% fibras tipo I",
      "70% fibras tipo II",
      "50% tipo I, 50% tipo II",
      "30% tipo I, 70% tipo II"
    ],
    correctAnswer: 3,
    explanation: "El esternocleidomastoideo tiene predominio de fibras tipo II (70%), adaptadas para movimientos rápidos y potentes. Sin embargo, tiene una proporción significativa de fibras tipo I (30%) para control postural fino de la cabeza."
  },
  
  {
    id: 10229,
    muscle: 'esternocleidomastoideo',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.RELACION,
    question: "¿Qué fascia cubre al esternocleidomastoideo?",
    options: [
      "Fascia cervical superficial",
      "Fascia cervical media",
      "Fascia cervical profunda",
      "Todas las anteriores"
    ],
    correctAnswer: 3,
    explanation: "El esternocleidomastoideo está cubierto por la fascia cervical superficial, media (que forma la vaina carotídea) y profunda. Esta cobertura fascial múltiple proporciona estabilidad y permite el deslizamiento durante movimientos cervicales."
  },
  
  {
    id: 10230,
    muscle: 'esternocleidomastoideo',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.FUNCION,
    question: "¿Por qué el esternocleidomastoideo es importante en la deglución?",
    options: [
      "Elevación del hueso hioides",
      "Movimiento de la laringe",
      "Coordinación con constrictores faríngeos",
      "Todas las anteriores"
    ],
    correctAnswer: 3,
    explanation: "El esternocleidomastoideo contribuye a la deglución mediante elevación del hueso hioides, movimiento de la laringe y coordinación con los constrictores faríngeos. Su contracción ayuda a proteger las vías aéreas durante la deglución."
  },
  
  // ========== NIVEL COMPLEJO (10) ==========
  
  {
    id: 10231,
    muscle: 'esternocleidomastoideo',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.CASO_CLINICO,
    question: "Paciente con tortícolis congénita presenta cabeza inclinada y rotada. ¿Qué músculo está afectado?",
    options: [
      "Trapecio contralateral",
      "Esternocleidomastoideo ipsilateral",
      "Elevador de la escápula",
      "Romboides"
    ],
    correctAnswer: 1,
    explanation: "El tortícolis congénito (contractura del esternocleidomastoideo) causa cabeza inclinada hacia el lado afectado y rotada hacia el lado contralateral. Se debe a hematoma intrauterino o posición fetal anómala. El tratamiento incluye fisioterapia y liberación quirúrgica si no responde."
  },
  
  {
    id: 10232,
    muscle: 'esternocleidomastoideo',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.DIAGNOSTICO,
    question: "Paciente con dolor cervical y tumor parotídeo maligno. EMG muestra denervación. ¿Qué nervio está lesionado?",
    options: [
      "Nervio facial",
      "Nervio glosofaríngeo",
      "Nervio accesorio",
      "Nervio hipogloso"
    ],
    correctAnswer: 2,
    explanation: "La denervación del esternocleidomastoideo y trapecio indica lesión del nervio accesorio. Los tumores parotídeos pueden infiltrar o comprimir este nervio durante su trayecto. La EMG confirma la denervación y ayuda a localizar el nivel de lesión."
  },
  
  {
    id: 10233,
    muscle: 'esternocleidomastoideo',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.QUIRURGICA,
    question: "¿Qué abordaje se utiliza para biopsia del esternocleidomastoideo?",
    options: [
      "Abordaje anterior longitudinal",
      "Abordaje posterior",
      "Abordaje lateral sobre el borde anterior",
      "Abordaje endoscópico"
    ],
    correctAnswer: 2,
    explanation: "El abordaje lateral sobre el borde anterior del esternocleidomastoideo permite acceso directo al músculo sin lesionar estructuras vasculonerviosas profundas. Es útil para biopsia en sospecha de miopatías inflamatorias o neoplasias."
  },
  
  {
    id: 10234,
    muscle: 'esternocleidomastoideo',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.IMAGENOLOGIA,
    question: "En RM del cuello, ¿qué hallazgo confirma tortícolis muscular congénita?",
    options: [
      "Engrosamiento difuso del músculo",
      "Acortamiento fibrótico con atrofia",
      "Aumento de señal en T2-STIR",
      "Calcificaciones intratendinosas"
    ],
    correctAnswer: 1,
    explanation: "La RM en tortícolis congénita muestra acortamiento fibrótico del esternocleidomastoideo con atrofia de las fibras musculares. Las imágenes sagitales y coronales permiten evaluar la extensión de la fibrosis y planificar el tratamiento quirúrgico."
  },
  
  {
    id: 10235,
    muscle: 'esternocleidomastoideo',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.CORRELACION_CLINICA,
    question: "¿Qué complicación puede causar la contractura del esternocleidomastoideo?",
    options: [
      "Plagiocefalia",
      "Asimetría facial",
      "Limitación de la rotación cervical",
      "Todas las anteriores"
    ],
    correctAnswer: 3,
    explanation: "La contractura del esternocleidomastoideo puede causar plagiocefalia (deformidad craneal), asimetría facial y limitación de la rotación cervical. En niños, puede afectar el desarrollo craneofacial si no se trata tempranamente."
  },
  
  {
    id: 10236,
    muscle: 'esternocleidomastoideo',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.CASO_CLINICO,
    question: "Paciente con parálisis del esternocleidomastoideo post-disección cervical radical. ¿Qué movimiento está limitado?",
    options: [
      "Flexión cervical",
      "Rotación de cabeza al lado contralateral",
      "Inclinación lateral al mismo lado",
      "Todas las anteriores"
    ],
    correctAnswer: 3,
    explanation: "La parálisis del esternocleidomastoideo limita la flexión cervical, rotación de la cabeza al lado contralateral e inclinación lateral al mismo lado. Los pacientes compensan con los músculos profundos del cuello y trapecio contralateral."
  },
  
  {
    id: 10237,
    muscle: 'esternocleidomastoideo',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.DIAGNOSTICO,
    question: "Evaluación EMG muestra denervación selectiva del esternocleidomastoideo. ¿Qué segmento medular sugiere?",
    options: [
      "C1-C2",
      "C2-C3",
      "C3-C4",
      "C4-C5"
    ],
    correctAnswer: 0,
    explanation: "La denervación selectiva del esternocleidomastoideo sugiere lesión del nervio accesorio en su origen (C1-C2), antes de que inerve al trapecio. Lesiones más distales afectarían ambos músculos. La EMG ayuda a localizar el nivel de lesión."
  },
  
  {
    id: 10238,
    muscle: 'esternocleidomastoideo',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.QUIRURGICA,
    question: "¿Qué técnica se utiliza para liberar contractura congénita del esternocleidomastoideo?",
    options: [
      "Tenotomía simple",
      "Liberación fascial bipolar",
      "Miotomía con resección segmentaria",
      "Transferencia tendinosa"
    ],
    correctAnswer: 1,
    explanation: "La liberación fascial bipolar (resección del segmento fibroso entre ambas cabezas) es la técnica estándar para contractura congénita del esternocleidomastoideo. Se realiza alrededor de los 6-12 meses de edad, seguida de férula y fisioterapia para corregir la deformidad."
  },
  
  {
    id: 10239,
    muscle: 'esternocleidomastoideo',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.IMAGENOLOGIA,
    question: "En ecografía del cuello, ¿qué maniobra confirma contractura del esternocleidomastoideo?",
    options: [
      "Rotación pasiva de la cabeza",
      "Palpación directa durante contracción",
      "Compresión transversal del músculo",
      "Movimiento de deglución"
    ],
    correctAnswer: 1,
    explanation: "La ecografía con palpación directa durante contracción voluntaria confirma contractura del esternocleidomastoideo. Muestra engrosamiento fibrótico y falta de elasticidad normal. Es útil para diferenciar contractura de otras causas de tortícolis."
  },
  
  {
    id: 10240,
    muscle: 'esternocleidomastoideo',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.CORRELACION_CLINICA,
    question: "Paciente con hipertrofia compensatoria del esternocleidomastoideo contralateral. ¿Qué explica esto?",
    options: [
      "Adaptación por debilidad homolateral",
      "Sobrecarga postural",
      "Efecto de Saunders",
      "Todas las anteriores"
    ],
    correctAnswer: 0,
    explanation: "La hipertrofia compensatoria del esternocleidomastoideo contralateral ocurre por debilidad homolateral (parálisis o contractura). El músculo contralateral se sobrecarga para mantener la función cervical. Requiere rehabilitación equilibrada para prevenir desequilibrios musculares."
  }
];
